import { render } from "./OverdueModal.vue?vue&type=template&id=0cd14edb&scoped=true"
import script from "./OverdueModal.vue?vue&type=script&lang=js"
export * from "./OverdueModal.vue?vue&type=script&lang=js"

import "./OverdueModal.vue?vue&type=style&index=0&id=0cd14edb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd14edb"]])

export default __exports__